import classNames from 'classnames';
import { Link } from 'react-router-dom';

const WIDGET_LINK_CLASS = [
  'inline-flex min-w-0 max-w-full items-center rounded-sm font-medium',
  'text-indigo-200 underline decoration-2 decoration-indigo-400/80 underline-offset-4',
  'transition-colors hover:text-white hover:decoration-indigo-200',
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-900',
].join(' ');

function WidgetLink({ to, className, children, ...props }) {
  return (
    <Link
      to={to}
      className={classNames(WIDGET_LINK_CLASS, className)}
      {...props}
    >
      {children}
    </Link>
  );
}

export default WidgetLink;
